var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"tab-group"},_vm._l((_vm.routes),function(route){return _c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: route.name , params: route.params }}},[_c('span',[_vm._v(_vm._s(route.text))])])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }